<template>
  <d2-container>
    <div class="solutions">
      <div class="solutionsbanner" @click="goToSptResources">
        <div class="clickBtn">
          <button class="buyBtn" >
            立即购买
          </button>
        </div>
      </div>
      <div class="solutionsbasecont">
        <div class="solutionsSectionTxt">
          作为响应东数西算政策的绿电算力云运营商，“算力城市”正式发布基于 NVIDIA Hopper 架构的 H200 裸金属 GPU 集群和容器云集群，现面向企业、高校及开发者开放首单优惠，享受<span> 12 元/卡时 </span>，本次开放的 H200 算力池具有以下特性：
        </div>
      </div>
      <div class="bgMsg" >
         <!-- <img src="/image/portalimg/domestic/bgMsg.png"> -->
      </div>
      <div class="bgMsgh5">
         <img src="/image/portalimg/domestic/bgMsgh5.png">
      </div>
      <div class="solutionsbasecont">
        <div class="solutionsSection1">
          <div class="lf solutionsSection1Text">
            <p>活动期间所有 H200 算力<span>首单享受 12 元/卡时</span>，数量有限，先到先得！</p>
            <p>采用科研优先的智能调度策略。注册即享：</p>
            <p>分布式训练优化工具包</p>
            <p>专属架构师 1v1 方案咨询</p>
            <p>即刻访问算力城市官网抢占测试资格</p>
          </div>
          <div class="rf solutionsSection1img">
            <img src="/image/portalimg/domestic/weChatImg.png">
            <p>（人工咨询）</p>
          </div>
        </div>
      </div>
      <div class="solutionsbasecont solutionsbasecont1584">
        <div class="solutionsSection2">
          <div class="solutionsSection2Cont">
            <h4>方案与架构咨询</h4>
            <p>关于使用场景和技术架构的更多咨询，请联系我们的销售和技术支持团队。</p>
          </div>
          <button class="contactBtn" @click="goToSptResources"></button>
        </div>
      </div>

      <base-bottom></base-bottom>
    </div>
  </d2-container>
</template>

<script>
import baseBottom from '../components/base-bottom'

export default {
  name: 'solutions',
  components: {
    baseBottom
  },
  data() {
    return {
      
    }
  },
  methods: {
    goToSptResources() {
      this.$router.push({
        path: '/sptResources',
      });
    }
  },
}
</script>

<style scoped>
*, body, html {
  margin: 0;
  padding: 0;
  width: 100%;
}

.lf {
  float: left;
}

.rf {
  float: right;
}

@media (min-width: 769px) {
    /* PC端样式 */

.solutionsbanner {
  background: url(/image/portalimg/domestic/bannerH200.png) no-repeat center center;
  height: auto;
  height: 500px;
  margin-top: 60px;
  background-size: 1920px 500px;
  cursor: pointer;
}
.clickBtn{
  width: 200px;
  height: 52px;
  margin: 0 auto;
  padding-top: 399px;
}
.buyBtn{
  background: #FF8028;
  box-shadow: 0px 2px 4px 0px rgba(7,0,196,0.5);
  border: 0;
  border-radius: 8px;
  width: 200px;
  height: 52px;
  text-align: center;
  font-size: 24px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
}

.solutionsbasecont {
  width: 1560px;
  margin: 0 auto;
  overflow: hidden;
}
.solutionsbasecont1584{
  width: 1584px;
  margin: 0 auto;
  overflow: hidden;
}
.bgMsg{
  display: block;
  width:1890px;
  height:766px;
  margin: 0 auto;
  background: url(/image/portalimg/domestic/bgMsg.png) no-repeat center center;
  background-size: 1920px 100%;
}
.bgMsgh5{
  display: none;
}

.solutionsSectionTxt{
  font-size: 24px;
  color: #000000;
  letter-spacing: 0;
  line-height: 48px;
  font-weight: 400;
  padding: 100px 0 112px;
}
.solutionsSectionTxt span {
  font-size: 34px;
  color: #2070E7;
  font-weight: 600;
}
.solutionsSection1{
  overflow: hidden;
  padding: 107px 0 100px;
}
.solutionsSection1 .solutionsSection1Text{
  width: 1200px;
}
.solutionsSection1 .solutionsSection1Text p{
  font-size: 24px;
  color: #000000;
  letter-spacing: 0;
  line-height: 62px;
  font-weight: 400;
}
.solutionsSection1 .solutionsSection1Text span{
  font-size: 38px;
  color: #2070E7;
  font-weight: 600;
}
.solutionsSection1 .solutionsSection1img{
  margin-top: 122px;
  width: 136px;
  height: 136px;
}
.solutionsSection1 .solutionsSection1img p{
  margin-top: 6px;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  font-weight: 400;
  width: 136px;
  text-align: center;
}

.solutionsSection2 {
  padding-bottom: 86px;
  position: relative;
}
.solutionsSection2Cont {
  height: 320px;
  background: url(/image/portalimg/domestic/solutionsSetion2.png) no-repeat center center;
  background-size: 1584px 100%;
}
.contactBtn{
  position: absolute;
  width: 160px;
  height: 60px;
  top: 82px;
  right: 52px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0);
  border: 0;
}

.solutionsSection2Cont h4 {
  font-size: 32px;
  color: #FFFFFF;
  letter-spacing: 4px;
  font-weight: 500;
  padding: 49px 60px 20px;
}

.solutionsSection2Cont p {
  color: #fff;
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 2.25px;
  font-weight: 500;
  padding-left: 60px;
}

}

@media (max-width: 768px) {
    /* 移动端样式 */

.solutionsbanner {
  background: url(/image/portalimg/domestic/bannerH200h5.png) no-repeat center center;
  height: auto;
  background-size: 100% 100%;
  width: 100%;
  height: 250px;
  margin-top: 60px;
  cursor: pointer;
}
.clickBtn{
  width: 100px;
  height: 52px;
  margin: 0 auto;
  padding-top: 187px;
}
.buyBtn{
  background: #FF8028;
  -webkit-box-shadow: 0px 2px 4px 0px rgba(7, 0, 196, 0.5);
  box-shadow: 0px 2px 4px 0px rgba(7, 0, 196, 0.5);
  border: 0;
  border-radius: 4px;
  width: 100px;
  height: 32px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  margin: 0 auto;
  font-weight: bold;
}

.solutionsSectionTxt{
  margin: 0 5%;
  width:90%;
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 400;
  padding: 40px 0 50px;
}
.solutionsSectionTxt span {
  font-size: 20px;
  color: #2070E7;
  font-weight: 600;
}
.bgMsg{
  display: none;
}
.bgMsgh5{
  display: block;
}

.solutionsSection1{
  overflow: hidden;
  padding: 40px 0 50px;
}
.solutionsSection1 .solutionsSection1Text{
  width: 90%;
  margin: 0 5%;
}
.solutionsSection1 .solutionsSection1Text p{
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 400;
}
.solutionsSection1 .solutionsSection1Text span{
  font-size: 20px;
  color: #2070E7;
  font-weight: 600;
}
.solutionsSection1 .solutionsSection1img{
  margin-top: 30px;
  margin-right: 5%;
  width: 80px;
  height: 80px;
  float: left;
  margin-left: 5%;
}
.solutionsSection1 .solutionsSection1img p{
  margin-top: 6px;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  font-weight: 400;
  width: 84px;
  text-align: center;
}
    .solutionsSection2 {
      padding-bottom: 40px;
      position: relative;
    }

    .solutionsSection2 h2 {
      font-size: 20px;
      color: #000000;
      letter-spacing: 4px;
      text-align: center;
      font-weight: 600;
      padding: 30px 0 20px;
    }

    .solutionsSection2Cont {
      background: url(/image/portalimg/domestic/solutionsSetion2.png) no-repeat center center;
      background-size: 100% 100%;
      height: 93px;
      width: 90%;
      margin: 0 5%;
    }

    .solutionsSection2Cont h4 {
      font-size: 13px;
      color: #FFFFFF;
      letter-spacing: 4px;
      font-weight: 500;
      padding: 15px 0 6px;
      margin-left: 5%;
    }

    .solutionsSection2Cont p {
      font-size: 8px;
      color: #FFFFFF;
      /* letter-spacing: 2px; */
      font-weight: 500;
      width: 72%;
      padding-left: 5%;
    }
    .contactBtn{
      position: absolute;
      width: 12%;
      height: 23px;
      top: 21px;
      right: 7%;
      cursor: pointer;
      background: rgba(0, 0, 0, 0);
      border: 0;
    }
}
</style>
